import RefType from './RefType';

const mappingMasterCommon = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  document_included: 'document_included',
};

export default {
  // Cấu hình mapping master
  FieldMappingMaster: {
    // Rút tiền kho bạc
    [[RefType.BUTreasuryWithdrawal, RefType.BADeposit].join('-')]: {
      ...mappingMasterCommon,
    },
    // Ckkb
    [[RefType.BUTransfer, RefType.CAPayment].join('-')]: {
      ...mappingMasterCommon,
    },
    [[RefType.BUTransfer, RefType.BADeposit].join('-')]: {
      ...mappingMasterCommon,
    },

    // ckkb vào tktg
    [[RefType.BUTransferDeposit, RefType.BADeposit].join('-')]: {
      bank_account: 'bank_account',
      bank_name: 'bank_name',
    },
  },
  // Các trường k mapping detail
  FieldNotMapping: {
    // Sinh từ rút tiền kho bạc
    [[RefType.BUTreasuryWithdrawal, RefType.CAPayment].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTreasuryWithdrawal, RefType.BADeposit].join('-')]: [
      'org_voucher_no',
      'org_voucher_date',
      'auto_business_id',
      'auto_business_code',
      'quantity',
      'real_unit_price',
      'unit_price',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTreasuryWithdrawal, RefType.BAWithDraw].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],

    // SInh từ ckkb
    [[RefType.BUTransfer, RefType.CAPayment].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTransfer, RefType.BADeposit].join('-')]: [
      'org_voucher_no',
      'org_voucher_date',
      'auto_business_id',
      'auto_business_code',
      'quantity',
      'real_unit_price',
      'unit_price',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTransfer, RefType.BAWithDraw].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],

    // Sinh từ ckkb vào tktg
    [[RefType.BUTransferDeposit, RefType.CAPayment].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTransferDeposit, RefType.BADeposit].join('-')]: [
      'org_voucher_no',
      'org_voucher_date',
      'auto_business_id',
      'auto_business_code',
      'quantity',
      'real_unit_price',
      'unit_price',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
    [[RefType.BUTransferDeposit, RefType.BAWithDraw].join('-')]: [
      'auto_business_id',
      'auto_business_code',
      'cash_withdraw_type_id',
      'cash_withdraw_type_name',
    ],
  },
};
